<template>
  <div>
    <a-button type="primary" @click="showModal">
      Open Modal
    </a-button>
    <a-modal v-model="visible" :footer="null" class="h-5/6">
      <n-card style="max-width: 640px;" :bordered="false" size="huge" class="card">
        <div class="title">お気に入りエリア</div>
        <div class="description1">お気に入りに入れたいエリア名を入力してください。</div>
        <div class="btn-cms">
          <a-select class="mw-select" v-model="value" :options="options" :placeholder="Chooseyourfavorite" />
        </div>
        <div class="btn-cms">
          <button class="c-btn btn-grey">
            <span class="">変更する</span>
          </button>
        </div>
      </n-card>
    </a-modal>
  </div>
</template>

<script>

export default {
  data () {
    return {
      visible: false,
      value: 'Choose your favorite',
      options: [
        {
          label: '東京都',
          value: '東京都'
        },
        {
          label: 'Norwegian Wood',
          value: 'song2'
        },
        {
          label: 'You Won\'t See',
          value: 'song3',
          disabled: true
        },
        {
          label: 'Nowhere Man',
          value: 'song4'
        }
      ]
    }
  },
  methods: {
    showModal() {
      this.visible = true
    },
    handleOk() {
      this.visible = false
    }
  }
}
</script>
<style lang="scss" scoped>
  @import './style.scss';
</style>